export default "__VITE_ASSET__254e007d__"